var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokenLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "broken-branch-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".broken-icon{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "broken-icon",
    x1: 5,
    y1: 5,
    x2: 2.43,
    y2: 2.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "broken-icon",
    x1: 17.57,
    y1: 17.57,
    x2: 15,
    y2: 15
  }), /*#__PURE__*/React.createElement("path", {
    className: "broken-icon",
    d: "m7.44,10.07c-1.02-.21-2.13.08-2.92.87l-2.57,2.57c-1.25,1.25-1.25,3.29,0,4.55,1.25,1.25,3.29,1.25,4.55,0l2.57-2.57c.79-.79,1.08-1.9.87-2.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "broken-icon",
    d: "m12.56,9.93c1.02.21,2.13-.08,2.92-.87l2.57-2.57c1.25-1.25,1.25-3.29,0-4.55-1.25-1.25-3.29-1.25-4.55,0l-2.57,2.57c-.79.79-1.08,1.9-.87,2.92"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLink);
export default __webpack_public_path__ + "static/media/broken-link.b45ed5dd1ef97d6d0234141c54d750db.svg";
export { ForwardRef as ReactComponent };